module.exports = __webpack_public_path__ + "img/blue-squares-icon.688ae6d9.svg";